const parseToRgba = colorStr => {
  if (typeof colorStr !== 'string') return undefined;
  const s = colorStr.trim();

  // HEX (#RGB, #RRGGBB, #RGBA, #RRGGBBAA)
  const hexRegex = /^#([A-Fa-f0-9]{3,8})$/;
  const rgbRegex = /^rgb\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
  const rgbaRegex = /^rgba\s*\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(0|1|0?\.\d+)\s*\)$/;

  // HEX
  if (hexRegex.test(s)) {
    let hex = s.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map(x => x + x)
        .join('');
    }
    if (hex.length === 4) {
      hex = hex
        .split('')
        .map(x => x + x)
        .join('');
    }
    if (hex.length === 6 || hex.length === 8) {
      const r = parseInt(hex.slice(0, 2), 16);
      const g = parseInt(hex.slice(2, 4), 16);
      const b = parseInt(hex.slice(4, 6), 16);
      let a = 1;
      if (hex.length === 8) {
        a = parseInt(hex.slice(6, 8), 16) / 255;
      }
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    }
    return undefined;
  }

  // RGB
  const rgbMatch = s.match(rgbRegex);
  if (rgbMatch) {
    const [_, r, g, b] = rgbMatch;
    return `rgba(${r}, ${g}, ${b}, 1)`;
  }

  // RGBA
  const rgbaMatch = s.match(rgbaRegex);
  if (rgbaMatch) {
    const [_, r, g, b, a] = rgbaMatch;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }

  // CSS color names (basic support)
  const ctx =
    typeof window !== 'undefined' ? window.document.createElement('canvas').getContext('2d') : null;

  if (ctx) {
    ctx.fillStyle = '#000';
    ctx.fillStyle = s;
    if (ctx.fillStyle !== '#000' || s.toLowerCase() === 'black') {
      ctx.fillRect(0, 0, 1, 1);
      const { data } = ctx.getImageData(0, 0, 1, 1);
      return `rgba(${data[0]}, ${data[1]}, ${data[2]}, ${data[3] / 255})`;
    }
  }

  return undefined;
};

module.exports = { parseToRgba };
